import { render, staticRenderFns } from "./CohortImport.vue?vue&type=template&id=3c8a72b0&"
import script from "./CohortImport.vue?vue&type=script&lang=js&"
export * from "./CohortImport.vue?vue&type=script&lang=js&"
import style0 from "./CohortImport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports